import { render, staticRenderFns } from "./ProfilePaymentDetailsSection.vue?vue&type=template&id=20523e8e"
import script from "./ProfilePaymentDetailsSection.vue?vue&type=script&lang=js"
export * from "./ProfilePaymentDetailsSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports